import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TLD() {
  const { t } = useTranslation();

  const benefits = [
    {
      number: '01',
      icon: 'ri-time-line',
      title: t('tld_benefit1_title'),
      description: t('tld_benefit1_desc')
    },
    {
      number: '02',
      icon: 'ri-shield-check-line',
      title: t('tld_benefit2_title'),
      description: t('tld_benefit2_desc')
    },
    {
      number: '03',
      icon: 'ri-team-line',
      title: t('tld_benefit3_title'),
      description: t('tld_benefit3_desc')
    },
    {
      number: '04',
      icon: 'ri-heart-pulse-line',
      title: t('tld_benefit4_title'),
      description: t('tld_benefit4_desc')
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[50vh] mt-16">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/e7605311edff4188dbd664db0f9809d3/d7979d43573bdac2b4459edc92a18da3.png"
            alt="Peaceful Ukrainian countryside landscape"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/20"></div>
        </div>

        <div className="absolute bottom-0 left-0 p-8 lg:p-16 text-white max-w-2xl">
          <div className="text-xs uppercase tracking-wider text-white/80 mb-2">{t('tld_hero_label')}</div>
          <h1 className="text-4xl lg:text-5xl font-medium mb-4 leading-tight">{t('tld_hero_title')}</h1>
          <p className="text-lg text-white/90 leading-relaxed">
            {t('tld_hero_subtitle')}
          </p>
        </div>
      </section>

      {/* What is TLD */}
      <section className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-medium text-stone-800 mb-8">{t('tld_what_title')}</h2>
          
          <div className="prose prose-lg prose-stone max-w-none">
            <p className="text-stone-700 leading-relaxed text-lg mb-6">
              {t('tld_what_p1')}
            </p>
            
            <p className="text-stone-700 leading-relaxed text-lg mb-6">
              {t('tld_what_p2')}
            </p>

            <div className="bg-stone-50 border-l-4 border-amber-500 p-6 my-8">
              <p className="text-stone-700 italic text-lg mb-0">
                "{t('tld_what_quote')}"
              </p>
            </div>

            <p className="text-stone-700 leading-relaxed text-lg">
              {t('tld_what_p3')}
            </p>
          </div>
        </div>
      </section>

      {/* Why TLD Matters */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('tld_why_title')}</h2>
            <p className="text-lg text-stone-600 leading-relaxed max-w-2xl mx-auto">
              {t('tld_why_subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg p-6 text-center shadow-sm">
                <div className="text-4xl font-light text-amber-500/20 mb-2">{benefit.number}</div>
                <div className="w-12 h-12 bg-amber-500/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-xl text-stone-700`}></i>
                </div>
                <h3 className="text-lg font-semibold text-stone-800 mb-3">{benefit.title}</h3>
                <p className="text-stone-600 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Current Reality */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('tld_reality_title')}</h2>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('tld_reality_p1')}
              </p>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('tld_reality_p2')}
              </p>
              <p className="text-stone-600 leading-relaxed">
                {t('tld_reality_p3')}
              </p>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/e7605311edff4188dbd664db0f9809d3/7ca1b91e990e33352753181df1e83ab7.png"
                alt="Veteran in contemplative moment"
                className="w-full rounded-lg shadow-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What We're Advocating For */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('tld_advocating_title')}</h2>
            <p className="text-stone-600 leading-relaxed">
              {t('tld_advocating_subtitle')}
            </p>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('tld_advocating1_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('tld_advocating1_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('tld_advocating2_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('tld_advocating2_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('tld_advocating3_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('tld_advocating3_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('tld_advocating4_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('tld_advocating4_desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-stone-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-medium mb-6">{t('tld_cta_title')}</h2>
          <p className="text-lg text-stone-300 leading-relaxed mb-8 max-w-2xl mx-auto">
            {t('tld_cta_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-stone-800 px-8 py-4 rounded-full font-medium hover:bg-amber-500 hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              {t('tld_cta_button1')}
            </a>
            <a
              href="/about"
              className="border border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-stone-800 transition-colors duration-300 whitespace-nowrap"
            >
              {t('tld_cta_button2')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}